import services from '@/config/services'

export default class PreavvisiFattureClientiService{
  
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
    this.baseUrlPratiche = `${services.ask_pratiche.url}`
  }

  async getAllFattureScadute(opts = {}){
    let item = {}

    if(!Object.keys(opts).length){
      opts = 'no-filters'
    }

    const url = `${this.baseUrl}/clienti/fatture/insolute/no-preavvisi/search`

    try {
      let res = await this.http.post(url, {filters: opts})
      res = res.data

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }

  }

  async getAllFattureInPreavviso(opts = {}){
    let item = {}

    if(!Object.keys(opts).length){
      opts = 'no-filters'
    }

    const url = `${this.baseUrl}/clienti/fatture/insolute/preavvisi/search`

    try {
      let res = await this.http.post(url, {filters: opts})
      res = res.data

      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }

  }

  async insertFattureToPreavvisi(opts){

    let result = false

    const url = `${this.baseUrl}/clienti/fatture/insolute/preavvisi`

    try {
      let res = await this.http.post(url, {
        filters: opts
      })
    
      res = res.data

      result = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        result
      }
    }

  }

  async downloadFilePreavvisiZip(opts){
    const url = `${this.baseUrl}/clienti/fatture/insolute/preavvisi/zip`
  
    try {
      const res = await this.http({
        url,
        method: 'POST',
        data: {
          filters: opts,
        },
        responseType: 'blob',
      })
      
      const blob = new Blob([res.data], {type: 'application/zip'});
      const fileName= window.decodeURI(res.headers['content-disposition'].split('=')[1], "UTF-8").split('"').join('')
  
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }


  async getInsolutiSummary(dates) {
    let items = {};
  
    const url = `${this.baseUrl}/clienti/fatture/insolute/preavvisi/summary`;
  
    try {
      let res = await this.http.post(url, { dates});
      items = res.data;
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
    } finally {
      this.eventBus.emit('data-loaded');
    }
  
    return {
      items
    };
  }

  async sendPreavvisi(objs){
    let items = {}
    const url = `${this.baseUrl}/clienti/fatture/insolute/preavvisi/invio-pec`

    try {
      let res = await this.http.post(url, {objs})

      items = res.data

    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items
      }
    }

  }

  async sendSolleciti5g(fd){
    let items = {}
    const url = `${this.baseUrl}/clienti/fatture/insolute/solleciti/invio-email`

    try {
      let res = await this.http.post(url, fd)

      items = res.data

    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items
      }
    }
  }

  async getFattureVenditaScadute(fd){
    let items = []
    const url = `${this.baseUrlPratiche}/get-fatture-vendita-scadute`

    try {
      let res =  await this.http.post(url, fd)
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }

  async getListSolleciti(view_point){
    let items = []
    const url = `${this.baseUrlPratiche}/get-solleciti-da-sospendere/${view_point}`

    try {
      let res =  await this.http.get(url)
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }

  async createMultiPreSuspensionOrReactivation(items, typeFornitura, typePratica){
    let result = []

    const url = `${this.baseUrlPratiche}/operation/preview/multi/sospensioni-riattivazioni`
    try {
      let res = await this.http.post(url, {items, typeFornitura, typePratica})
      result = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')      
      // eslint-disable-next-line no-unsafe-finally
      return {
          result,
      }
    }
  }
  async changeStatusSospendibilePP(fd){
    let items = {}
    const url = `${this.baseUrl}/change-status-sospendibile-pdp`

    try {
      let res = await this.http.post(url, fd)

      items = res.data

    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items
      }
    }
  }

  async getItemsLocked(){
    let items = []
    const url = `${this.baseUrl}/get-pp-suspension-locked`

    try {
      let res = await this.http.get(url)
      items = res.data
    } catch (err) {
        this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
        this.eventBus.emit('data-loaded')      
        // eslint-disable-next-line no-unsafe-finally
        return {
            items,
        }
    }
  }

  async getFattureScaduteOneYear(dates) {
    let items = [];
    const url = `${this.baseUrl}/clienti/fatture/scadute-one-year-ago`;

    try {
      let res = await this.http.post(url, dates);
      items = res.data;
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url });
    } finally {
      this.eventBus.emit('data-loaded');
    }

    return {
      items,
    };
  }

  async getLogErroriInviiPreavvisi(params = {}) {
    let data = {}
    const url = `${this.baseUrl}/clienti/fatture/insolute/preavvisi/log-errori`

    try {
      const res = await this.http.get(url, { params })
      data = res.data?.data || {}
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      throw err
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return data
  }


}
